var jQuery = require('jquery');
var console = require('console');
var Utils = require('../common/utils.js');
var codes = require('../common/codes.js');

var BasicEidCard = require('../card/basicEidCard.js');
var CardReaderMonitor = require('../card/cardReaderMonitor.js');


module.exports = ChromeExtensionApi;

function ChromeExtensionApi(config){

	var _cardReaderMonitor = null;

	
	function extensionCommunication(){
			
			//private state variables
			var _messageCounter = 0;
			var _messageIdToCallbackMap = {};

			var _eventListener = null;
			var _statusCodes = codes.statusCodes;

			//private functions
			function receiveMessage(message){
				console.debug("Webpage received message : " + JSON.stringify(message));
				if(typeof message.requestId != "undefined" && message.requestId != null){
					//it's a response to a request
					//find the callback
					var callback = _messageIdToCallbackMap[message.requestId.toString()];
					if(typeof callback != "undefined"){
						delete _messageIdToCallbackMap[message.requestId.toString()];
						callback(message);
					}else{
						console.warn("No callback found for message : " + JSON.stringify(message));
					}

				}else if(message.type.indexOf("_event") > 0){
					//it's card status event
					if(_eventListener){
						_eventListener(message);
					}
				}else{
					//it's an error
					console.log("Webpage received error : " + JSON.stringify(message));
				}
				
			};

			window.addEventListener("message", function(event) {
				// We only accept messages from ourselves
				if (event.source != window)
				   return;
				
				if (event.data.type && (event.data.type == "MESSAGE_FROM_EXTENSION")) {
					console.log("Did receive data from extension : " + event.data.text);
					receiveMessage( JSON.parse( event.data.text ));
				}
			});


			//public functions

			this.registerEventListener = function(eventListener){
					_eventListener = eventListener;
			}
			
			//communication
			this.sendMessage = function (message, callback){
				//add a unique id for the message
				message.requestId = _messageCounter++;
				_messageIdToCallbackMap[message.requestId.toString()] = callback;
				//TODO: check if we can change the target origin to something else than the defaul "*"
				window.postMessage({ type: "MESSAGE_FOR_EXTENSION", text: JSON.stringify(message) }, "*");
			};
			
			/**
			* Will return the latest reader list changed event as reader_list_change_event.
			*/
			this.status = function(){
				var statusDeferred = jQuery.Deferred();
				var message = {
						internalCommand : "readerStatus"
				};
				this.sendMessage(message, function(response){
					statusDeferred.resolve(response.return);
				});
				return statusDeferred.promise();
			};

			/**
			*	Check if the extension and native app installed
			*/
			this.serviceAvailability = function(){
				var serviceAvailabilityDeferred = jQuery.Deferred();
				//check if extension is available
				var message = {
					internalCommand : "extensionAvailability"
				};

				var extensionAvailable = false;
				var communicationInstance = this;
				this.sendMessage(message, function(response){
					// if we get a response the extension should be available
					extensionAvailable = response.return.available;
					console.debug("chrome extension is available");

					//check if native app is available
					var nativeAppAvailableMessage = {
						internalCommand : "nativeAppAvailability"
					};
					communicationInstance.sendMessage(nativeAppAvailableMessage, function(nativeAppResponse){
						if(nativeAppResponse.return.available){
							console.debug("chrome native app is available");
							serviceAvailabilityDeferred.resolve(_statusCodes.ok);

							communicationInstance.version().done(function(version){
								console.log("Native app is at version " + version);
							});

						}else{
							console.warn("native app for chrome extension is not installed");
							serviceAvailabilityDeferred.resolve(_statusCodes.nativeAppNotInstalled);
						}
					});

				});
				setTimeout(function(){
					if( ! extensionAvailable){
						console.warn("chrome extension is not installed");
						serviceAvailabilityDeferred.resolve(_statusCodes.extensionNotInstalled);
					}
				}, 200);

				return serviceAvailabilityDeferred.promise();
			};


			this.version = function(){
				var versionDeferred = jQuery.Deferred();
				var message = {
						command : "getVersion"
				};
				this.sendMessage(message, function(response){
					versionDeferred.resolve(response.return.version);
				});
				return versionDeferred.promise();
			};


			var extCommThis = this;
			this.eid = {

				_eidSendMessage : function(message, callback){
					extCommThis.sendMessage(message, function(data){
						if(typeof data.return.error != "undefined"){
							callback(null, {
								errorCode : codes.errorCodes.communicationError,
								message : data.return.error,
								internalError : data.return.diagnostic_information
							});
						}else{
							//a binary value is always returned as hex, we'll convert it to base64
							var returnValue = data.return;
							if(typeof returnValue.value != "undefined" && returnValue.value){
								returnValue.value = Utils.hexToBase64(returnValue.value);
							}
							callback(returnValue, null);
						}

					});
				},


				_readEidData : function(readerId, command, callback){
					extCommThis.eid._eidSendMessage({
						command : command,
						readerId : readerId
					}, callback);
				},

				_readEidDataSingleValue : function(readerId, command, callback){
					extCommThis.eid._readEidData(readerId, command, function(data, error){
						if(error == null){
							callback(data.value, null);
						}else{
							callback(null, error);
						}
					});
				},

				readCitizenCertificate : function(readerId, callback){
					extCommThis.eid._readEidDataSingleValue(readerId, "readCitizenCertificate", callback);
				},

				readRnData : function(readerId, callback){
					extCommThis.eid._readEidData(readerId, "readRnData", function(error , rnData){
						if(error != null){
							callback(error, null);
							return;
						}
						callback({
							name : rnData.name,
							firstName : rnData.firstName,
							altFirstName : rnData.altFirstName,
							thirdNameInitial : rnData.thirdNameInitial,
							cardNumber : rnData.cardNumber,
							dateStart : rnData.startDate,
							dateEnd : rnData.endDate,
							deliveryMunicipality : rnData.deliveryMunicipality,
							nationalNumber : rnData.nationalNumber,
							nationality : rnData.nationality,
							birthLocation : rnData.birthLocation,
							birthDate : rnData.birthDate,
							gender : rnData.gender,
							nobleCondition : rnData.nobleCondition,
							specialStatus : rnData.specialStatus,
							photoHashBase64 : Utils.hexToBase64( rnData.photoHash ),
							docType : rnData.docType,
							chipNumber : rnData.chipNumber
						});
					});
				},
				
				readRawRnData : function(readerId, callback){
					extCommThis.eid._readEidDataSingleValue(readerId, "readRawRnData", callback);
				},
				
				readAddressData : function(readerId, callback){
					extCommThis.eid._readEidData(readerId, "readAddressData", function(error , rnData){
						if(error != null){
							callback(error, null);
							return;
						}
						callback({
							streetFull : data.streetFull,
							street : data.street,
							number : data.number,
							numberExtra : data.numberExtra,
							zipCode : data.zipCode,
							municipality : data.municipality,
							leavingAbroad : data.leavingAbroad
						});
					});
				},
				
				readRawAddressData : function(readerId, callback){
					extCommThis.eid._readEidDataSingleValue(readerId, "readRawAddressData", callback);
				},
				
				readPhoto : function(readerId, callback){
					extCommThis.eid._readEidDataSingleValue(readerId, "readPhoto", callback);
				},
				
				readRnDataSignature : function(readerId, callback){
					extCommThis.eid._readEidDataSingleValue(readerId, "readRnDataSignature", callback);
				},
				
				readAddressDataSignature : function(readerId, callback){
					extCommThis.eid._readEidDataSingleValue(readerId, "readAddressDataSignature", callback);
				},
				
				readRnCertificate : function(readerId, callback){
					extCommThis.eid._readEidDataSingleValue(readerId, "readRnCertificate", callback);
				},
				
				readRootCertificate : function(readerId, callback){
					extCommThis.eid._readEidDataSingleValue(readerId, "readRootCertificate", callback);
				},
				
				readAuthenticationCeritifcate : function(readerId, callback){
					extCommThis.eid._readEidDataSingleValue(readerId, "readAuthenticationCertificate", callback);
					
				},
				
				readNonRepudationCertificate : function(readerId, callback){
					extCommThis.eid._readEidDataSingleValue(readerId, "readNonRepudiationCertificate", callback);
				},

				signRsaWithPin : function(readerId, pin, dataToSign, callback){
					extCommThis.eid._signOrAuthenticiateRsa(readerId, "signRsa", pin, dataToSign, callback);
				},

				authenticateRsaWithPin : function(readerId, pin, dataToSign, callback){
					extCommThis.eid._signOrAuthenticiateRsa(readerId, "authenticateRsa", pin, dataToSign, callback);
				},

				_signOrAuthenticiateRsa : function(readerId, command, pin, dataToSign, callback){
					extCommThis.eid._eidSendMessage({
						command : command,
						readerId : readerId,
						data : Utils.base64ToHex( dataToSign ), //TODO: convert to hex
						pin : pin
					}, function(signatureResult, error){
						if(error != null){
							callback(null, error);
							return;
						}
						//format the result
						if( ! signatureResult.pinOk ||  signatureResult.pinOk === "false"){

							var error  = {
								message : "Invalid pin",
								errorCode : codes.errorCodes.communicationError
							};
							switch( parseInt( signatureResult.triesLeft, 10 )){
								case 0: error.errorCode = codes.errorCodes.wrongPinCardBlocked; break;
								case 1: error.errorCode = codes.errorCodes.wrongPinOneTryLeft; break;
								case 2: error.errorCode = codes.errorCodes.wrongPinTwoTriesLeft; break;
							}
							callback(null, error);

						}else{
							callback(signatureResult.value, null);
						}


					});
				}

			};
			
	};

	/*** eid card implementation for the middleware ***/
	

	function EidCard(readerId){
		
		BasicEidCard.call(this);

		var _readerId = readerId;

		
		this.readCitizenCertificate = function(callback){
			ExtensionCommunication.eid.readCitizenCertificate(_readerId, callback);
		}
		
		this.readRnData = function(callback){
			ExtensionCommunication.eid.readRnData(_readerId, callback);	
		}
		
		this.readRawRnData = function(callback){
			ExtensionCommunication.eid.readRawRnData(_readerId, callback);
		}
		
		this.readAddressData = function(callback){
			ExtensionCommunication.eid.readAddressData(_readerId, callback);
		}
		
		this.readRawAddressData = function(callback){
			ExtensionCommunication.eid.readRawAddressData(_readerId, callback);
		}
		
		this.readPhoto = function(callback){
			ExtensionCommunication.eid.readPhoto(_readerId, callback);
		}
		
		this.readRnDataSignature = function(callback){
			ExtensionCommunication.eid.readRnDataSignature(_readerId, callback);
		}
		
		this.readAddressDataSignature = function(callback){
			ExtensionCommunication.eid.readAddressDataSignature(_readerId, callback);
		}
		
		this.readRnCertificate = function(callback){
			ExtensionCommunication.eid.readRnCertificate(_readerId, callback);
		}
		
		this.readRootCertificate = function(callback){
			ExtensionCommunication.eid.readRootCertificate(_readerId, callback);
		}
		
		this.readAuthenticationCeritifcate = function(callback){
			ExtensionCommunication.eid.readAuthenticationCeritifcate(_readerId, callback);
			
		}
		
		this.readNonRepudationCertificate = function(callback){
			ExtensionCommunication.eid.readNonRepudationCertificate(_readerId, callback);
		}
		
		
		this.stopSigningSession = function(){
			this.resetPin();				
		}
		
		this.signRsaWithPin = function(pin, dataToSign, callback){
			ExtensionCommunication.eid.signRsaWithPin(_readerId, pin, dataToSign, callback);
		}
		
		this.authenticateRsaWithPin = function(pin, dataToSign, callback){
			ExtensionCommunication.eid.authenticateRsaWithPin(_readerId, pin, dataToSign, callback);
		}

		
	}
	
	//inheritd from the basic card:
	
	EidCard.prototype = Object.create( BasicEidCard.prototype);
	EidCard.prototype.constructor = EidCard;



	//init the communication wiht the extension

	function eventHandler(event){
		var cardReaderMonitor = getCardReaderMonitor();
		if(event.type === "reader_list_change_event"){
			//convert to readerDiscriptions
			handleReaderEventList(event);
		}else if(event.type === "card_status_change_event"){
			for(var i = 0; i < event.card_list.length; i++){
				var card = event.card_list[i];
				switch(card.state){
					case "removed" : cardReaderMonitor.cardRemoved(card.reader); break;
					case "eid_detected" : cardReaderMonitor.correctCardInserted(card.reader , new EidCard(card.reader)); break;
					case "muted" : cardReaderMonitor.cardIncorrectInserted(card.reader); break;
					case "other_detected" : cardReaderMonitor.incorrectCardInserted(card.reader); break;
					default : console.log("Unknown cardstate " + JSON.stringify(card));
				}
			}

		}else{
			console.log("received unknown event " + JSON.stringify(event));
		}

	}

	function handleReaderEventList(readerListEvent){
		var cardReaderMonitor = getCardReaderMonitor();
		//convert to readerDiscriptions
		var readerDiscriptions = new Array();
		for(var i = 0; i < readerListEvent.readerlist.length ; i++){
			readerDiscriptions.push({
				name: readerListEvent.readerlist[i],
				type: CardReaderMonitor.readerTypes.pcscReader
			});
		}
		cardReaderMonitor.updateConnectedReaders(readerDiscriptions);
	}
	
	//TODO: make a nicer solution
	var ExtensionCommunication = new extensionCommunication();
	ExtensionCommunication.registerEventListener(eventHandler);

	
	function checkStatus(){
		return ExtensionCommunication.serviceAvailability();
	};
	
	function getCardReaderMonitor(){
		if(_cardReaderMonitor == null){
			_cardReaderMonitor = new CardReaderMonitor();
		}
		return _cardReaderMonitor;
	};

	//make sure we got the latest status of the connected readers
	function setMonitorUpToDate(){
		ExtensionCommunication.status().done(function(readerListEvent){
			handleReaderEventList(readerListEvent);
		}).fail(function(error){
			console.error("failed to set the initial state of the monitor : " + JSON.stringify(error));
		});
	}
	setMonitorUpToDate();
	
	
	
	
	return {
		checkStatus : checkStatus,
		getCardReaderMonitor : getCardReaderMonitor().getPublicApi,
		statusCodes : codes.statusCodes
	};
	
}